import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMyContext } from "../context/MyContext";

const SignUpForm1 = ({ code }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [number, setNumber] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  // const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [referral, setReferral] = useState(code);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [authToken, setAuthToken] = useState(""); // Make sure to set the actual token
  const { email, isLoading, setEmail, setIsLoading } = useMyContext();

  const navigate = useNavigate();

  // Load state from local storage on component mount
  useEffect(() => {
    const savedState =
      JSON.parse(localStorage.getItem("signupForm1State")) || {};
    //setFullName(savedState.fullName || "");
    setUsername(savedState.username || "");
    setEmail(savedState.email || "");
    setPassword(savedState.password || "");
    setReferral(savedState.referral || code);
    setAgreeTerms(savedState.agreeTerms || false);
  }, []);

  // Save state to local storage whenever it changes
  useEffect(() => {
    let fullName = `${firstName} ${lastName}`.trim();
    const stateToSave = {
      fullName,
      email,
    };
    localStorage.setItem("signupForm1State", JSON.stringify(stateToSave));
  }, [firstName, lastName, email]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSendOtp = async (e) => {
    // e.preventDefault();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/register/otp?email=${email}`
      );

      const data = response.data;

      if (data.Access) {
        if (data.Sent) {
          toast.success("OTP sent successfully");
          // navigate("register2");
        } else {
          toast.error("Sending OTP failed: OTP not sent");
        }
      } else {
        toast.error(data.Error || "Unknown error");
      }
    } catch (error) {
      toast.error(error.response?.data?.Error || "Unknown error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let fullName = `${firstName} ${lastName}`.trim();

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/auth/register/1`,
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken, // Make sure authToken is defined
        },
        data: JSON.stringify({
          FullName: fullName,
          Username: username,
          PhoneNumber: number,
          Email: email,
          Password: password,
          Referral: referral,
        }),
      });

      const data = response.data;

      if (data.Access) {
        if (data.Registered) {
          handleSendOtp();
          navigate(`/register2/${email}`);
        } else {
          toast.error("Registration failed: User not registered");
        }
      } else {
        toast.error(data.Error || "Unknown error");
      }
    } catch (error) {
      toast.error(error.response?.data?.Error || "Unknown error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full">
      <h2 className="text-[30px] lg:text-[40px] font-extrabold text-black">
        Get Started on BUZZY
      </h2>
      <p className="text-base font-normal text-gray-600">
        Create a new account with us and get started...
      </p>

      <form className="mt-4" onSubmit={handleSubmit}>
        <div className="relative z-0 w-full">
          <label
            htmlFor="firstName"
            className="block text-base font-semibold text-black"
          >
            First Name
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            placeholder="Enter your first name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
          />
        </div>

        <div className="relative z-0 w-full mt-4">
          <label
            htmlFor="lastName"
            className="block text-base font-semibold text-black"
          >
            Last Name
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Enter your last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
          />
        </div>

        <div className="relative z-0 w-full mt-4">
          <label
            htmlFor="username"
            className="block text-base font-semibold text-black"
          >
            Username
          </label>
          <input
            type="text"
            id="username"
            name="username"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
            required
          />
          <p className="mt-2 mb-4 text-[13px] text-gray-500 font-normal">
            Your username is also your handle. Make sure you create something
            unique and interesting.
          </p>
        </div>

        <div className="relative z-0 w-full mt-4">
          <label
            htmlFor="number"
            className="block text-base font-semibold text-black"
          >
            Phone Number
          </label>
          <input
            type="number"
            id="number"
            name="number"
            placeholder="Your phone number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
          />
        </div>

        <div className="relative z-0 w-full mt-4">
          <label
            htmlFor="email"
            className="block text-base font-semibold text-black"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
          />
        </div>

        <div className="relative z-0 w-full mt-4">
          <label
            htmlFor="password"
            className="block text-base font-semibold text-black"
          >
            Password
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
              minLength={6}
            />
            <button
              type="button"
              className="absolute top-1/2 right-2 transform -translate-y-1/2 cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <FaEye size={22} color="#404040" />
              ) : (
                <FaEyeSlash size={22} color="#404040" />
              )}
            </button>
          </div>
          <p className="mt-2 mb-4 text-[13px] text-gray-500 font-normal">
            Password must contain at least 6 characters, 1 symbol, 1 capital
            letter, and 1 small letter.
          </p>
        </div>

        <div className="relative z-0 w-full mt-4">
          <label
            htmlFor="referral"
            className="block text-base font-semibold text-black"
          >
            Referrer’s Username (Optional)
          </label>
          <input
            type="text"
            id="referral"
            name="referral"
            placeholder="Enter your referral code"
            value={referral}
            onChange={(e) => setReferral(e.target.value)}
            className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
          />
        </div>

        <div className="my-4 flex items-center">
          <input
            type="checkbox"
            id="agreeTerms"
            checked={agreeTerms}
            onChange={() => setAgreeTerms(!agreeTerms)}
            className="mr-2"
          />
          <label htmlFor="agreeTerms" className="text-sm text-gray-600">
            By signing up, you agree to our{" "}
            <Link to="#" className="text-[#405AC6] font-medium">
              Terms and Privacy Policy
            </Link>
          </label>
        </div>

        <button
          type="submit"
          disabled={!agreeTerms}
          className="w-full py-3 mt-6 bg-[#405AC6] text-white rounded-xl hover:bg-blue-800 transition-colors duration-300"
        >
          Create an account
        </button>

        <p className=" text-base mt-5 text-gray-900 font-normal text-center">
          Don’t have an account on buzzy?
          <Link
            to="/login"
            className="login-text text-[#405AC6] font-medium"
          >
           {' '} Login now
          </Link>
        </p>
      </form>
    </div>
  );
};

export default SignUpForm1;
